import { io } from "socket.io-client";
import { BASE_URL } from "../server";
// npm install socket.io-client --legacy-peer-deps


const SOCKET_URL = BASE_URL; // Replace with your server URL
const socket = io(SOCKET_URL, {
  transports: ['websocket'], // Optional: Specify the transport protocol
});

socket.on('connect_error', (error) => {
  console.error('WebSocket connection error:', error);
});

export default socket;
